// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Add = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="3px"
    >
      <path d="M7.15,23.83h33.78H7.15Z" />
      <path d="M23.96,40.72V6.94s0,33.78,0,33.78Z" />
    </svg>
  );
};
